// --- Paleta Google Gemini ---
// Identidad: degradado azul -> purpura -> coral.
export const GEMINI_BLUE = "#4285F4";
export const GEMINI_BLUE_DARK = "#1A73E8";
export const GEMINI_PURPLE = "#9168C0";
export const GEMINI_PINK = "#D96570";
export const GEMINI_GRADIENT = "linear-gradient(135deg, #4285F4 0%, #9168C0 55%, #D96570 100%)";
export const GEMINI_GRADIENT_R = "linear-gradient(90deg, #4285F4 0%, #9168C0 55%, #D96570 100%)";
export const GEMINI_GRADIENT_SOFT = "linear-gradient(135deg, rgba(66,133,244,0.10), rgba(145,104,192,0.10), rgba(217,101,112,0.10))";

export const colors = {
    LandingPage_Background: '#FFFFFF',
    LandingPage_Description: '#373737',
    Button_Primary: '#000000',
    Button_Secondary: '#333333',
    Header_Background: "#FFFFFF",
    Header_Content: '#000000',
    Black: '#000000',
    Header: '#000000',
    Header_Text: "#FFFFFF",
    Header_Text_back: "#1a1a1a",
    Table_Header: '#F6F6F6',
    Action_Button_Back: '#000000',
    ALERT_BUTTON_GOTO_COLOR: "#c6e2f6",
    ALERT_BUTTON_CLOSE_COLOR:  "#ea969d",
    HEADER: '#000000',
    SHADOW_LIGHT: "#d6d6d6", // Renamed from SHADOW to avoid duplicate
    CAR_BOX_EVEN:'#F6F6F6',
    CAR_BOX_ODD:'#EEEEEE',
    CARD_LABEL:"#4C5152",
    CARD_DETAIL:"#F5F5F5",
    STATUS_COMPLETE:"#2CDE3A",
    STATUS_CANCELED:"#DF2E38",
    STATUS_PENDING:"##FFCD4B",
    ROW_SELECTED:"#F2F2F2",
    TABLE_BORDER:"rgba(224, 224, 224, 1)",
    SUB_2:"#000000",
    WALLET_CARD:"#000000",
    WALLET_CARD_SHADOW:"#9E9E9E",
    FACEBOOK_COLOR:"#3b5998",
    BLUE:"#000000",

  // Gemini expuesto en colors para uso directo en vistas.
  GEMINI_BLUE,
  GEMINI_BLUE_DARK,
  GEMINI_PURPLE,
  GEMINI_PINK,
  GEMINI_GRADIENT,
  GEMINI_GRADIENT_R,
  GEMINI_GRADIENT_SOFT,

  // Color principal negro para todas las categorias (paleta web en negro).
  TAXIPRIMARY: "#000000",
  TAXISECONDORY: "#F6F6F6",

  DELIVERYPRIMARY: "#000000",
  DELIVERYSECONDORY: "#F6F6F6",

  BIDTAXIPRIMARY: "#000000",
  BIDTAXISECONDORY: "#F6F6F6",

  TRANSPARENT: "transparent",
  WHITE: "#ffffff",
  BLACK: "#000000",
  RED: "#FF1E00",
  GREEN: "#0CAB03",
  YELLOW: "#FFDE59 ",
  VIOLET:"#000000",
  SHADOW: "#cccccc",
}